// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2elZqlvGZt7lAuyNGABqC8{list-style-type:none;padding:0}._3t--eowJZOxUF0iHOx2Fjk{display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": "_2elZqlvGZt7lAuyNGABqC8",
	"item": "_3t--eowJZOxUF0iHOx2Fjk"
};
module.exports = ___CSS_LOADER_EXPORT___;
